var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import React from 'react';
var Section = function (_a) {
    var children = _a.children, stopPosition = _a.stopPosition, line = _a.line, flex = _a.flex, color = _a.color, style = _a.style;
    return (React.createElement("div", { style: __assign({ display: 'flex', flex: flex ? 1 : undefined }, style) },
        line === 'arrow' ? (React.createElement("div", { style: { height: 28, alignSelf: 'flex-end' } },
            React.createElement("svg", { width: "24", height: "28", viewBox: "0 0 24 28", xmlns: "http://www.w3.org/2000/svg" },
                React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 28V17.7357L9.79985 1.28339C10.8352 -0.427797 13.1648 -0.427797 14.1743 1.28339L24 17.7473V28L0 28Z", fill: color })))) : (React.createElement("div", { style: {
                width: 24,
                background: color,
                marginTop: line === 'terminate' ? stopPosition : undefined,
                height: line === 'none' ? 0 : undefined,
            } })),
        stopPosition && (React.createElement("div", { style: { marginTop: stopPosition, marginLeft: -28, marginRight: -4 } },
            React.createElement("svg", { width: "32", height: "32", viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", style: { marginTop: -16 } },
                React.createElement("circle", { cx: "16", cy: "16", r: "14", fill: "white", stroke: "black", strokeWidth: "4" })))),
        React.createElement("div", { style: { marginLeft: 52, flex: 1 } }, children)));
};
export default Section;



//////////////////
// WEBPACK FOOTER
// ./src/pages/MonitorDisplay/Section.tsx
// module id = 324
// module chunks = 0